import React from 'react';
import { numberLayer } from 'pu-data/SelectOptions';
import { numberOfLayers as tooltip } from 'pu-data/Tooltips';
import SelectComponent from './base/SelectComponent';
import PropTypes from 'prop-types';

const NumberLayer = (props) => {
  const onChange = e => props.onChangeParameter(props.name, e.target.value, props.itemId);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={props.name}
      onChange={props.onChange || onChange}
      options={props.options}
      tooltip={tooltip}
      selected={props.parameters.number_of_layers}
      groupName={props.groupName} />
  );
};

NumberLayer.defaultProps = {
  label: '# of Layers',
  name: 'number_of_layers',
  options: numberLayer,
  required: true,
  itemId: '',
};

NumberLayer.propTypes = {
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
}

export default NumberLayer;
